import React from "react";
import { Box, Typography } from "@mui/material";
import {
  formatFieldValue,
  formatSquareFootageNumber,
  isSquareFootageType,
} from "./detailsDialogUtils";

function DetailsFieldsPanel(props) {
  const { entry, fieldValues, totalSquareFeet } = props;

  return (
    <Box className="browse-designs-details-fields-wrap">
      <Box className="browse-designs-details-fields-grid browse-designs-fields">
        <Box className="browse-designs-field-row browse-designs-details-total-row">
          <span>Total Square Feet</span>
          <Box
            className="browse-designs-details-field-value"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-end",
              whiteSpace: "nowrap",
              width: "100%",
            }}
          >
            <Typography component="span" sx={{ fontWeight: 600 }}>
              {totalSquareFeet === null ? (
                "-"
              ) : (
                <>
                  {totalSquareFeet} ft<sup>2</sup>
                </>
              )}
            </Typography>
          </Box>
        </Box>

        {fieldValues.map((fieldValue, idx) => {
          const squareFootageField = isSquareFootageType(fieldValue?.fieldId?.type);
          const baseFieldName = fieldValue?.fieldId?.name || "Unnamed field";
          const squareFootageNumber = squareFootageField
            ? formatSquareFootageNumber(fieldValue?.value)
            : null;

          return (
            <Box
              key={`${entry?._id || "entry"}-details-field-${idx}`}
              className="browse-designs-field-row"
            >
              <span>
                {squareFootageField ? (
                  <>
                    {baseFieldName} (ft<sup>2</sup>)
                  </>
                ) : (
                  baseFieldName
                )}
              </span>
              <span className="browse-designs-details-field-value">
                {squareFootageField && squareFootageNumber !== null ? (
                  <>
                    {squareFootageNumber} ft<sup>2</sup>
                  </>
                ) : (
                  formatFieldValue(fieldValue?.value)
                )}
              </span>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export default DetailsFieldsPanel;
